import React, { useEffect, useRef, useState } from "react";

//Компоненты
// import SignIn from "./Singin/SingIn";

//Стили и пропсы
// import WrapperRightSide from "./MainPage/WrapperMainFile";
import { BrowserRouter, HashRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "../provider/ThemeProvider";

import { lazy, Suspense } from "react";
import LoadingMask from "./MainPage/NotWorkArea(Side&Head)/LoadingMask";
import CheckMobile from "./lk/CheckMobile";
import { webkcrypt_invoke } from "./TokenProcessing/TokenProcessing";
import webkcrypt_globals from "./dualplug/webkcrypt_globals";
import cadesplugin_api from "./dualplug/cadesplugin_api";
import webkcrypt_create from "./dualplug/webkcrypt";
import { saveDataBD } from "./MainPage/Tools/IndexedBd";
import { isEmptyObject, isSessionActive } from "./MainPage/Tools/Tools";
import { useAtom, useSetAtom } from "jotai";
import { appConfig, isAuthorized, smetaStore } from "../atoms";
import axios from "axios";
import wrapperStyles from "./wrapper.module.css";
import clsx from "clsx";

const SignIn = lazy(() => import("./Singin/SingIn")); //обычный вход в смету
const WrapperRightSide = lazy(() => import("./MainPage/WrapperMainFile")); //Рабочая часть где все секции  т д
const SignInLK = lazy(() => import("./lk/SignIn")); //вход в лк
const SignUpUmi = lazy(() => import("./lk/SignUp/SignUpUMI")); //регистрация для лк УМИ
const SignUp = lazy(() => import("./lk/SignUp/SignUp")); // стандратная регистрация для ЛК
const RestorePassword = lazy(() => import("./lk/RestorePassword")); //смена пароля только для ЛК уми

export const theme = React.createContext("");

function showNotif() {
  //отображаем уведомление для янао
  const config = smetaStore.get(appConfig);
  if (config.lk.checkNotifyme === true && config.lk.textContentNotifyme) {
    const div = document.createElement("div");
    const closeDiv = document.createElement("div");
    closeDiv.id = "close";
    closeDiv.onclick = () => {
      div.style.display = "none";
    };
    div.id = "notifyme";
    div.className = "display";
    const content = `<p>Уважаемые пользователи!</p>
    ${config.lk.textContentNotifyme}`;
    div.innerHTML = content;
    div.appendChild(closeDiv);
    document.body.appendChild(div);
  }
}

async function logErrorToDatabase(error) {
  const data = [];
  console.log(error);
  const errorObj = {
    filename: error.filename,
    line: error.lineno,
    message: error.message,
  };
  data.push(errorObj);
  await saveDataBD("smeta", "errors", errorObj);
}

const snowActive = () => {
  const snowflakes = document.querySelector(".snowflakes-box");

  const snowball = document.querySelector(".snowball-box");

  return snowflakes && snowball;
};

const Wrapper = () => {
  const [config, setConfig] = useAtom(appConfig);
  const [checkedSession, setCheckedSession] = useState(false);
  const [loadConfig, setLoadConfig] = useState(true);
  const setIsAutorized = useSetAtom(isAuthorized);

  const checkSessionActive = async () => {
    const sessionInfo = await isSessionActive();
    const licGUID = sessionInfo.licGUID;
    if (licGUID) {
      sessionStorage.setItem("LicG", licGUID);
    }
    if (!sessionInfo.active) {
      localStorage.setItem("login", "");
    }
    setIsAutorized(sessionInfo.active);
    setCheckedSession(true);
  };

  const uploadConfig = async () => {
    try {
      const location = window.location;
      const replacedPathName = location.pathname.replace("/index.html", "");
      const response = await axios.get(`${location.origin}${replacedPathName}/config.json`);
      const responseConfig = response.data;
      if (typeof responseConfig === "object" && !isEmptyObject(responseConfig)) {
        const {
          smeta: { multiSession },
        } = responseConfig;
        setConfig({
          ...responseConfig,
          smeta: {
            ...responseConfig.smeta,
            stimateVersion: config.smeta.stimateVersion,
            multiSession: multiSession === undefined ? true : multiSession,
          },
        });
      }
    } catch (error) {
      console.warn(error.message);
    } finally {
      setLoadConfig(false);
    }
  };

  const smetaWebInitialization = async () => {
    webkcrypt_globals();
    cadesplugin_api();
    webkcrypt_create();
    await uploadConfig();
    await checkSessionActive();
    if (!snowActive()) new Snow();
    window.addEventListener("error", logErrorToDatabase);
  };

  useEffect(() => {
    smetaWebInitialization();
    return () => {
      window.removeEventListener("error", logErrorToDatabase);
    };
  }, []);

  String.prototype.replaceAt = function (index, replacement) {
    return this.substring(0, index) + replacement + this.substring(index + replacement.length);
  };

  function detectMob() {
    const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  window.onload = function () {
    webkcrypt_invoke("webkcrypt-check-updates", null, (event) => {
      // nothing
    });
    showNotif();
  };
  if (!checkedSession || loadConfig) return <LoadingMask />;
  if (config && config.lk && config.lk.baseUmi !== "1" && detectMob() && window.innerWidth < 650) {
    return <CheckMobile />;
  } else
    return (
      <main className={clsx(wrapperStyles.main)}>
        {/* <BrowserRouter basename={config.smeta.basename}> */}
        <HashRouter>
          <Routes>
            <Route
              path="/"
              element={
                <Suspense fallback={<LoadingMask />}>
                  {config.smeta.hideEnter !== undefined && config.smeta.hideEnter === true ? <SignInLK /> : <SignIn />}
                </Suspense>
              }
            />
            {config.smeta.hideEnter !== true && (
              <Route
                path="/lk"
                element={
                  <Suspense fallback={<LoadingMask />}>
                    <SignInLK />
                  </Suspense>
                }
              />
            )}
            {config.lk.baseUmi === "1" && (
              <Route
                path="/restorepassword"
                element={
                  <Suspense fallback={<LoadingMask />}>
                    <RestorePassword />
                  </Suspense>
                }
              />
            )}
            <Route
              path="/signup"
              element={
                <Suspense fallback={<LoadingMask />}>{config.lk.baseUmi === "1" ? <SignUpUmi /> : <SignUp />}</Suspense>
              }
            />
            <Route
              path="/main"
              element={
                <ThemeProvider>
                  <Suspense fallback={<LoadingMask />}>
                    <WrapperRightSide />
                  </Suspense>
                </ThemeProvider>
              }
            />
          </Routes>
        </HashRouter>
        {/* </BrowserRouter> */}
      </main>
    );
};

export default Wrapper;
